import { render, staticRenderFns } from "./riderlist.vue?vue&type=template&id=4cca916f&"
import script from "./riderlist.vue?vue&type=script&lang=js&"
export * from "./riderlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports